export default "__VITE_ASSET__B4_ybD0I__"